module.exports = __webpack_public_path__ + "static/media/arrow-left.eb4213a2.svg";